var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("booking-form", {
        attrs: {
          "property-mutator": _vm.setBookingPropertyMutator,
          duplicated: true,
          "validation-triggered": false,
          booking: _vm.booking,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-primary",
              attrs: { click: _vm.handleDuplicateBookingCallback },
            },
            [_vm._t("button")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }